import { ChangeDetectionStrategy, Component, input, output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { IOnboardingCompletion } from '../fi-onboarding-completion';
import { FiAttachmentDisplaySize } from '@fi-shared/types';

@Component({
    selector: 'fi-onboarding-completion-short-info',
    templateUrl: './fi-onboarding-completion-short-info.component.html',
    styleUrl: './fi-onboarding-completion-short-info.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    host: { class: 'fi-onboarding-completion-short-info' },
})
export class FiOnboardingCompletionShortInfoComponent {
    public onboardingCompletion = input.required<IOnboardingCompletion>();
    public isOnboardingNameDisplayed = input<boolean>(true);
    public userStepsCount = input.required<number>();
    public completedStepsCount = input.required<number>();
    public completionEndDate = input<Date | string>();
    public maxDescriptionLines = input<number>(2);

    public isToggleButtonVisible = input<boolean>(false);
    public isExpanded = input<boolean>(true);
    public isBackButtonVisible = input<boolean>(false);
    public actionsTemplate = input<TemplateRef<any>>(null);
    public toggleButtonClick = output<void>();
    public backButtonClick = output<void>();

    protected toggleContentExpansionState($event: MouseEvent): void {
        $event.stopPropagation();
        this.toggleButtonClick.emit();
    }

    protected readonly FiAttachmentDisplaySize = FiAttachmentDisplaySize;
}
